import { FC } from 'react';
import { useIntl } from 'react-intl';
import { Applications } from '@clds/icon';
import { MENU_ITEM_ICON_SIZE } from '../../../ApplicationWrapper.const';
import { messages } from '../../../i18n';
import { PrimaryMenuItemDropdownMenu } from '../../PrimaryMenuItemDropdownMenu/PrimaryMenuItemDropdownMenu';
import { ApplicationsDropdownItems } from '../ApplicationsDropdownWrapper/ApplicationsDropdownItems';

export interface ApplicationsDropdownButtonProps {
  showVideoAppSelector?: boolean;
}

export const ApplicationsDropdownButton: FC<ApplicationsDropdownButtonProps> = ({ showVideoAppSelector }) => {
  const { formatMessage } = useIntl();

  return (
    <PrimaryMenuItemDropdownMenu
      items={<ApplicationsDropdownItems showVideoAppSelector={showVideoAppSelector} />}
      analyticsMessage="products menu"
      tooltipTitle={formatMessage(messages.applicationsMenuTooltip)}
      minWidth="lg"
      size="sm"
    >
      <Applications size={MENU_ITEM_ICON_SIZE} />
    </PrimaryMenuItemDropdownMenu>
  );
};
